<template>
<div id="catalogo_mt" >
    <v-power-catalogo :parametros="parametros" />
</div>
</template>

<script>
import powerCatalogo from "@/views/apendices/layout.vue";
export default {
    components: {
        "v-power-catalogo": powerCatalogo
    },
    mounted() {},

    data: () => ({
        fab: false,
        parametros: {
            url_actions: "apendices/",
            url_list: "apendices/lista/",
            tabla: 10,
            title: "CLAVES DE MONEDAS",
            columns: ["clave", "descripcion", "pais", "actions"],
            options: {
                filterable: ["clave", "descripcion", "pais"],
                sortable: ["clave", "descripcion", "pais"],

                headings: {
                    clave: "Clave",
                    descripcion: "Descripción",
                    pais: "País",
                    actions: "Operaciones"
                }
            },
            camposexcel: {
                Clave: "clave",
                Descripción: "descripcion",
                País: "pais"
            },
            encabezadoLayout: {
                clave: "clave",
                descripcion: "descripcion",
                pais: "pais"
            },
            camposLayout: [{
                clave: "[Clave de Moneda]",
                descripcion: "[Descripción de la Moneda]",
                pais: "[Clave de País]"
            }],
            model: {
                id: 0,
                clave: "",
                descripcion: "",
                pais: ""
            },
            form: {
                clave: {
                    requiered: true,
                    label: "Clave",
                    value: "",
                    maxlen: 10
                },
                descripcion: {
                    requiered: true,
                    label: "Descripción",
                    value: "",
                    maxlen: 200
                },
                pais: {
                    requiered: true,
                    label: "País",
                    value: "",
                    maxlen: 100
                }
            },
            breadcrumbs: [{
                    text: "Inicio",
                    disabled: false,
                    to: "/home"
                },
                {
                    text: "Utilerías",
                    disabled: true,
                    to: ""
                },
                {
                    text: "Apendices",
                    disabled: true,
                    to: ""
                }
            ]
        }
    })
};
</script>
<style scoped>
.VueTables >>> thead th {
  white-space: normal !important;
}

.VueTables >>> tbody td{
  white-space: normal !important;
}
</style>